import { apiClient } from '../../../gateways/api'
import type { HoofdnetOpdracht } from '../types/HoofdnetOpdracht'

export { fetchHoofdnetOpdracht }

const fetchHoofdnetOpdracht = async (id: string): Promise<HoofdnetOpdracht> => {
  const { data } = await apiClient({
    url: `/rest/opdracht-hoofdnet/${id}`,
    method: 'GET',
  })

  return data
}
